var map = {
	"./camp_shirt_gk1.svg": "7024",
	"./camp_shirt_gk10.svg": "192e",
	"./camp_shirt_gk11.svg": "c539",
	"./camp_shirt_gk12.svg": "82b7",
	"./camp_shirt_gk2.svg": "5e46",
	"./camp_shirt_gk3.svg": "78c8",
	"./camp_shirt_gk4.svg": "61e6",
	"./camp_shirt_gk5.svg": "cf01",
	"./camp_shirt_gk6.svg": "827f",
	"./camp_shirt_gk7.svg": "fb48",
	"./camp_shirt_gk8.svg": "96b4",
	"./camp_shirt_gk9.svg": "4ef1",
	"./camp_shirt_other1.svg": "15f2",
	"./camp_shirt_other10.svg": "c119",
	"./camp_shirt_other11.svg": "24c7",
	"./camp_shirt_other12.svg": "dd05",
	"./camp_shirt_other2.svg": "17d0",
	"./camp_shirt_other3.svg": "599d",
	"./camp_shirt_other4.svg": "d46e",
	"./camp_shirt_other5.svg": "23af",
	"./camp_shirt_other6.svg": "b32e",
	"./camp_shirt_other7.svg": "cdae",
	"./camp_shirt_other8.svg": "fdfc",
	"./camp_shirt_other9.svg": "b272"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8158";